import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {withContext} from '../../../custom/StateProvider';
import {connect} from "react-redux";
import {API, BROKERID} from "../../../../config";
import Utils from "../../../custom/utils";
import _ from "lodash";
//import {InputAdornment, Table, TableBody, TableCell, TableHead, TableRow, TextField} from "@material-ui/core";
//import classNames from "classnames";

var moment = require('moment-timezone');

//const holdings = API.service('holdings');

const styles = theme => ({
  root                    : {},

  avatar                  : {},

  reportTable             : {
    width                 :'100%',
    paddingTop            : '30px'
  },

  reportHeading           : {
    fontWeight            :'bold'
  }
});

const CompletedTrades = API.service('completed-trades');

class CompletedTradesReport extends Component {
  state = {
    holdings: false,
    completedOrder: null,
    count:0,
  }

  componentDidMount() {
    //const app = this;
    this.updateData()
  }

  updateData = () => {
    const app = this;
    //let order = [];
    let query = {};

    var complete = [];
    CompletedTrades.find({ query: { $sort: { createdAt: -1 }, $or: {_selling_broker_id: BROKERID, _buying_broker_id: BROKERID}, $limit: 200,...query, incl: ['brokers','company'] } }).then(ct => {
      console.log('Completed Trades:',ct);
      complete = _.merge(ct.data, complete);
      complete = _.orderBy(complete, ['_ts_executed'], ['desc']);

      //console.log('wtf',ct);

      app.setState({
        completedOrder: complete,
        count: ct.total
      });
    })

    /*let addQuery = {};
    if(this.props.selectedCompany){
      addQuery = {_company_account:this.props.selectedCompany.account_number}
    }*/

    /*CompletedTrades.find({ query: { type:'CrossBroker',...addQuery , startDate:'2019-01-10'} }).then(ct => {
      console.log('blahblah',ct);
      app.setState({
        cross_broker : ct
      })
    })*/
  }

  render() {
    const { classes} = this.props;
    const { completedOrder} = this.state;
    //let count = 0;
    return (
      <React.Fragment>
        {(completedOrder !== null) &&
        <table className={classes.reportTable}>
          <thead>
          <tr className={classes.row}>
            <td className={classes.cell}>
              <span style={{height: 24}}>Order Complete</span>
            </td>
            <td className={classes.cell}>
              <span style={{height: 24}}>Seller</span>
            </td>
            <td className={classes.cell}>
              <span style={{height: 24}}>Buyer</span>
            </td>
            <td className={classes.cell}>
              <span style={{height: 24}}>Qty</span>
            </td>
            <td className={classes.cell}>
              <span style={{height: 24}}>Price</span>
            </td>
            <td className={classes.cell}>
              <span style={{height: 24}}>Total Commission</span>
            </td>
          </tr>
          </thead>

          <tbody>
          {
            completedOrder.map(v => {
              let currency = Utils.getCurrency(v.currency),
                  bc = (v._buying_broker_id === parseInt(BROKERID, 10)) ? parseFloat(v._buy_commission) : 0,
                  sc = (v._selling_broker_id === parseInt(BROKERID, 10)) ? parseFloat(v._sell_commission) : 0;
              return (
                  <tr key={v._id} className={classes.row}>
                    <td className={classes.cell} component="th">
                      {moment.tz(v.createdAt, 'UTC').format('YYYY-MM-DD HH:mm')}
                    </td>
                    <td className={classes.cell}>{v._selling_investor_account} ({v.Selling_Broker[0]._name})</td>
                    <td className={classes.cell}>{v._buying_investor_account} ({v.Buying_Broker[0]._name})</td>
                    <td className={classes.cell}>{Utils.addThousandCommas(v._quantity)}</td>
                    <td className={classes.cell}>{currency.currency_symbol}{Utils.addThousandCommas(v._price)}</td>
                    <td className={classes.cell}>{currency.currency_symbol}{Utils.addThousandCommas(bc + sc)}</td>
                  </tr>
              )
            })
          }
          </tbody>

        </table>
        }
      {(this.state.count === 0) &&
        <div style={{marginTop:15,textAlign:'center'}}>No Results</div>
      }
      </React.Fragment>
    )
  }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(CompletedTradesReport))));
